import { findDataInFields } from "../../../utils/helperFuctions";

const TextDisplay = ({
  label,
  type,
  name,
  fields,
  displayValue,
  displayValue2,
}) => {
  const value = findDataInFields(fields, displayValue);
  let value2 = findDataInFields(fields, name + ".class");
  if (typeof value2 === "object") {
    value2 = value2.name;
  }
  if (value == null) {
    return null;
  }

  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-gray-900 text-left">
        {label}
      </label>
      <div className="block text-sm font-medium leading-6 text-[#6b7280] text-left">
        {value}
      </div>
      <div className="block text-sm font-medium leading-6 text-[#6b7280] text-left">
        {value2}
      </div>
    </div>
  );
};

export default TextDisplay;
